import React from 'react';

const Categories = () => <div>under construction</div>;

export default Categories;
